/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { Route, Switch, HashRouter, Redirect } from 'react-router-dom';
import { features } from 'configs';
import { EHRContextProvider } from 'contexts/EHRContext';
import { EHRPage } from 'pages/EHRPage';

export const EHRBypassRoutes = () => (
  <HashRouter>
    <Switch>
      <Route path="/registros">
        <EHRContextProvider urlInput={features.allowVisualizerFromURL}>
          <EHRPage />
        </EHRContextProvider>
      </Route>
      <Route exact path="/">
        <Redirect to="/registros" />
      </Route>
    </Switch>
  </HashRouter>
);
